<script setup>
import { useGlobalStore } from '@stores/global'
import { ref } from 'vue'

const global = useGlobalStore()
const props = defineProps(['modelValue', 'filter', 'type', 'required', 'placeholder', 'disabled', 'max', 'label', 'icon', 'error', 'autocomplete', 'spellcheck', 'autocapitalize', 'forgot'])
const emit = defineEmits(['update:modelValue'])

const input = ref(null)
const ov = ref(null)
const oss = ref(null)
const ose = ref(null)
const handlers = ref({
	input: handleInput,
	keyup: handleInput,
	keydown: handleInput,
	select: handleInput,
	contextmenu: handleInput,
	drop: handleInput,
})

function handleInput(event) {
	if (props.filter == 'username') {
		if (/^[a-zA-Z0-9_ ]*$/i.test(input.value.value)) {
			ov.value = input.value.value.replace(/-+/g, '').replace(/\s+/g, '_').replace(/\_\_+/g, '_').replace(/^_+/, '')
			oss.value = input.value.selectionStart
			ose.value = input.value.selectionEnd
			input.value.value = ov.value
			emit('update:modelValue', ov.value)
		} else if (ov.value) {
			input.value.value = ov.value
			emit('update:modelValue', ov.value)
			input.value.setSelectionRange(oss.value, ose.value)
		} else {
			input.value.value = ''
			emit('update:modelValue', '')
		}
	} else if (props.filter == 'phone') {
		if (/^[0-9+()-]*$/i.test(input.value.value)) {
			ov.value = input.value.value.replace(/\s+/g, '-').replace(/\-\-+/g, '-').replace(/^-+/, '')
			oss.value = input.value.selectionStart
			ose.value = input.value.selectionEnd
			input.value.value = ov.value
			emit('update:modelValue', ov.value)
		} else if (ov.value) {
			input.value.value = ov.value
			emit('update:modelValue', ov.value)
			input.setSelectionRange(oss.value, ose.value)
		} else {
			input.value.value = ''
			emit('update:modelValue', '')
		}
	} else {
		emit('update:modelValue', event.target.value)
	}
}
</script>

<template>
	<div class="flex w-full flex-col gap-2 normal-case">
		<label class="text-xs font-medium" v-if="label">
			{{ label }}
		</label>

		<div class="relative flex w-full">
			<i :class="'absolute left-4 top-1/2 -translate-y-1/2 text-sm text-neutral-500 ' + icon"></i>
			<input :class="{ 'icon-padding': icon }" :type="type || 'text'" :placeholder="placeholder" :maxlength="max" :required="required" v-on="handlers" :value="modelValue" :autocomplete="autocomplete" :disabled="disabled" :spellcheck="spellcheck" :autocapitalize="autocapitalize" ref="input" />
		</div>
		<p class="text-xs text-red-500" v-if="error">
			{{ error }}
		</p>
	</div>
</template>

<style scoped>
@reference '../../../css/theme.css';

input {
	@apply w-full grow rounded-lg border border-transparent bg-snk-light-500 px-4 py-3 text-sm normal-case placeholder:normal-case placeholder:text-black/40 focus:border-black/15 focus:outline-none;
}
.secondary input {
	@apply border border-black/15 focus:border-black/50;
}
</style>
